import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=4f8bbbd2&scoped=true&"
import script from "./HomeView.vue?vue&type=script&lang=js&"
export * from "./HomeView.vue?vue&type=script&lang=js&"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=4f8bbbd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8bbbd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/matt/dev/georgia/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8bbbd2')) {
      api.createRecord('4f8bbbd2', component.options)
    } else {
      api.reload('4f8bbbd2', component.options)
    }
    module.hot.accept("./HomeView.vue?vue&type=template&id=4f8bbbd2&scoped=true&", function () {
      api.rerender('4f8bbbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "HomeView.vue"
export default component.exports